import React, { useState } from 'react';
import Filter from '../../../../../Asset/images/icon/Filters-lines.svg';
import FilterModal from '../../../../../component/FilterModal';
import MobileViewSearch from '../../../../../component/MobileViewSearch';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const MobileSearch = ({
	tags,
	sortby,
	handleFilterChange,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	selectedProducts,
	setSelectedTags,
	setSelectedDurations,
	setselectedLevels,
	setSelectedInstructors,
	setSelectedProducts,
	instructors,
	products
}) => {
	const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

	const handleOpenFilterModal = () => {
		setIsFilterModalOpen(true);
	};

	const handleCloseFilterModal = () => {
		setIsFilterModalOpen(false);
	};

	const handleApplyFilter = (
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts
	) => {
		setSelectedTags(selectedTags);
		setselectedLevels(selectedLevels);
		setSelectedDurations(selectedDurations);
		setSelectedInstructors(selectedInstructors);
		setSelectedProducts(selectedProducts);
		setIsFilterModalOpen(false);
	};
	return (
		<div id="c-mobile_search">
			<div className="row m-0 c-tab_box">
				<div className="p-0">
					<div className="c-filter_btn">
						<MobileViewSearch />
						<div className="c-filter_btn-one c-mobile_filter_btn1">
							<img src={Filter} onClick={handleOpenFilterModal} alt="" />
							<span className="filterby-2">
								{isFilterModalOpen && (
									<FilterModal
										isOpen={isFilterModalOpen}
										tags={tags} 
										checkedTags={selectedTags}
										checkedDuration={selectedDurations}
										checkedLevels={selectedLevels}
										checkedInstructors={selectedInstructors}
										checkedProducts={selectedProducts}
										handleApplyFilter={handleApplyFilter}
										handleClose={handleCloseFilterModal}
										instructors={instructors}
										products={products}
									/>
								)}
							</span>
						</div>
						<div className="c-filter_btn-one c-mobile_filter_btn2">
							<ImportExportIcon size={24} />
							<span>Sort by</span>
							<select className="filterby" onChange={handleFilterChange} value={sortby}>
								<option value={'latest'}>Newest</option>
								<option value={'oldest'}>Oldest</option>
								<option value={'title_asc'}>Title (A - Z)</option>
								<option value={'title_desc'}>Title (Z - A)</option>
								<option value={'long_duration'}>Longest</option>
								<option value={'short_duration'}>Shortest</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MobileSearch;
